// Add your custom JS here.

import "uikit/dist/js/uikit.min.js";

document.addEventListener("DOMContentLoaded", () => {
	// Menu Scrolling
	const navbar = document.getElementById("wrapper-navbar");
	let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

	window.addEventListener("scroll", function () {
		const currentScroll =
			window.pageYOffset || document.documentElement.scrollTop;

		if (currentScroll > 250) {
			navbar.classList.add("scrolled");

			if (currentScroll < lastScrollTop) {
				// Scrolling up
				navbar.classList.add("scrolled-visible");
			} else {
				// Scrolling down
				navbar.classList.add("scroll-transition");
				setTimeout(() => {
					navbar.classList.remove("scrolled-visible", "scroll-transition");
				}, 300); // Timeout needs to match the transition duration
			}
		} else {
			// Top of page
			navbar.classList.add("scroll-transition");
			setTimeout(() => {
				navbar.classList.remove(
					"scrolled-visible",
					"scrolled",
					"scroll-transition"
				);
			}, 300); // Timeout needs to match the transition duration
		}

		lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // For Safari
	});
});

// jQuery-specifc code
jQuery(function ($) {
	// Menu Dropdowns
	var svgOpen =
		'<div class="dropdown-trigger position-absolute top-50 start-100 translate-middle text-center lh-1"><svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 512 512" width="24"><path fill="none" stroke="#ffffff" stroke-width="12" stroke-linecap="round" stroke-linejoin="round" d="M128 192l128 128 128-128"/></svg></div>';
	$("#main-nav .menu-item.dropdown").each(function () {
		// Appends the dropdown arrow
		$(this).append(svgOpen);
	});
	$("#main-nav .menu-item .dropdown-trigger").click(function () {
		// Toggles the dropdown
		$(this).siblings(".dropdown-menu").toggleClass("show");
	});
	// If #main-nav a.menu-item link is "#", open the dropdown instead of going to "#"
	$("#main-nav .menu-item a.nav-link").click(function (e) {
		if ($(this).attr("href") === "#") {
			e.preventDefault();
			$(this).siblings(".dropdown-menu").toggleClass("show");
		}
	});

	// Scrollspy classes
	$(".slide-in-bottom-md").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-bottom-medium; delay: 100"
	);
	$(".slide-in-left-md").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-left-medium; delay: 100"
	);
	$(".slide-in-right-md").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-right-medium; delay: 100"
	);
	$(".slide-in-bottom-sm").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-bottom-small; delay: 100"
	);
	$(".slide-in-left-sm").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-left-small; delay: 100"
	);
	$(".slide-in-right-sm").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-right-small; delay: 100"
	);
	$(".fade-in").attr("uk-scrollspy", "cls: uk-animation-fade; delay: 100");
	$(".fade-in-children").attr(
		"uk-scrollspy",
		"target: > *; cls: uk-animation-fade; delay: 100"
	);
	$(".slide-in-bottom-sm-children").attr(
		"uk-scrollspy",
		"target: > *; cls: uk-animation-slide-bottom-small; delay: 100"
	);
	$(".slide-in-bottom-md-children").attr(
		"uk-scrollspy",
		"target: > *; cls: uk-animation-slide-bottom-medium; delay: 100"
	);
	$(".slide-in-left-sm-children").attr(
		"uk-scrollspy",
		"target: > *; cls: uk-animation-slide-left-small; delay: 100"
	);

	// toTopButton
	if ($("#toTopButton").length) {
		$(window).on("scroll", function () {
			if ($(this).scrollTop() > 600) {
				$("#toTopButton").removeClass("hidden");
			} else {
				$("#toTopButton").addClass("hidden");
			}
		});
		// Smoothly scroll back to top when the button is clicked
		$("#toTopButton").on("click", function (event) {
			event.preventDefault();
			window.scrollTo({ top: 0, behavior: "smooth" });
		});
	}
});
